import { render, staticRenderFns } from "./Ecosystem.vue?vue&type=template&id=2a97f75c&scoped=true"
import script from "./Ecosystem.vue?vue&type=script&lang=js"
export * from "./Ecosystem.vue?vue&type=script&lang=js"
import style0 from "./Ecosystem.vue?vue&type=style&index=0&id=2a97f75c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97f75c",
  null
  
)

export default component.exports